module.exports = __webpack_public_path__ + "static/media/web-error.0c7863d7.jpg";